/**
 * Single source of truth for the app version string.
 * Bump manually with every user-visible release:
 *   • Small tweak / bug fix → 1.1 → 1.2 → 1.3
 *   • Larger release        → 1.9 → 2.0
 * Displayed at the bottom of the login screen.
 */
export const APP_VERSION = '1.6.20';
